/**
 * @generated SignedSource<<14588c3ae41b8abd69f15f8cc181e025>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShippingDetailsQuotesTable_viewer$data = {
  readonly itemDeliveryOptions?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly isCustom: boolean | null;
        readonly isLocalPickup: boolean | null;
        readonly serviceId: string | null;
        readonly serviceMethod: {
          readonly serviceMethodType: string | null;
          readonly serviceType: string | null;
          readonly windowMaxDays: number | null;
          readonly windowMinDays: number | null;
        } | null;
        readonly showQuoteAsPending: boolean | null;
        readonly sourceId: string | null;
        readonly totalAmount: {
          readonly amount: number | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTableRow_shipmentQuote">;
      } | null;
    } | null> | null;
  } | null;
  readonly transactionDeliveryOptions?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly isCustom: boolean | null;
        readonly isLocalPickup: boolean | null;
        readonly serviceId: string | null;
        readonly serviceMethod: {
          readonly serviceMethodType: string | null;
          readonly serviceType: string | null;
          readonly windowMaxDays: number | null;
          readonly windowMinDays: number | null;
        } | null;
        readonly showQuoteAsPending: boolean | null;
        readonly sourceId: string | null;
        readonly totalAmount: {
          readonly amount: number | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTableRow_shipmentQuote">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTableRow_viewer">;
  readonly " $fragmentType": "ShippingDetailsQuotesTable_viewer";
};
export type ShippingDetailsQuotesTable_viewer$key = {
  readonly " $data"?: ShippingDetailsQuotesTable_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTable_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "addressResolutionType",
  "variableName": "addressResolutionType"
},
v1 = {
  "kind": "Variable",
  "name": "country",
  "variableName": "country"
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v3 = {
  "kind": "Literal",
  "name": "isCheckout",
  "value": false
},
v4 = {
  "kind": "Variable",
  "name": "quantity",
  "variableName": "itemQuantity"
},
v5 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v6 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ShipmentQuoteEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShippingDetailsQuotesTableRow_shipmentQuote"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLocalPickup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showQuoteAsPending",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCustom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAmount",
            "kind": "LinkedField",
            "name": "totalAmount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShipmentServiceMethod",
            "kind": "LinkedField",
            "name": "serviceMethod",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceMethodType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "windowMinDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "windowMaxDays",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addressResolutionType"
    },
    {
      "kind": "RootArgument",
      "name": "country"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemQuantity"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchItemDelivery"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchTransactionDelivery"
    },
    {
      "kind": "RootArgument",
      "name": "transactionId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShippingDetailsQuotesTable_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShippingDetailsQuotesTableRow_viewer"
    },
    {
      "condition": "shouldFetchItemDelivery",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "itemDeliveryOptions",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/)
          ],
          "concreteType": "ShipmentQuoteConnection",
          "kind": "LinkedField",
          "name": "availableDeliveryOptions",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ]
    },
    {
      "condition": "shouldFetchTransactionDelivery",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "transactionDeliveryOptions",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "Variable",
              "name": "transactionId",
              "variableName": "transactionId"
            },
            (v5/*: any*/),
            (v6/*: any*/)
          ],
          "concreteType": "ShipmentQuoteConnection",
          "kind": "LinkedField",
          "name": "availableDeliveryOptions",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "9fc8993d9289c500135c4c44440adb99";

export default node;
